import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { AppSelect } from 'shared/UI/UIKit/Select';
import { USER_DATE_FORMAT } from 'shared/constants/date';
import { AppTableControls } from 'common/TableControls/TableControls';
import type { Period } from 'services/api/calendars';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import { getDisabledDate } from '../lib';

const vacationPeriodOptions = [
  { label: 'Каникулярный', value: 'true' },
  { label: 'Учебный', value: 'false' },
];

export const getColumns = (
  handleFieldChange: (key: number, field: string, value: any) => void,
  handleDeleteRow: (id: number) => void,
  calendarName?: string,
): AppTableColumn<Period>[] => [
  {
    key: 'vacationPeriod',
    title: 'Тип периода',
    dataIndex: ['vacationPeriod'],
    render: (value: boolean, record: Period) => (
      <AppSelect
        value={String(value)}
        style={{
          minWidth: '200px',
          display: 'flex',
          alignItems: 'center',
        }}
        options={vacationPeriodOptions}
        onChange={(newValue: string) => handleFieldChange(record.id, 'vacationPeriod', newValue)}
      />
    ),
  },
  {
    key: 'date',
    title: 'Дата периода',
    dataIndex: ['startDate'],
    render: (startDate: string, record: Period) => {
      const endDate = record.endDate;

      return (
        <DatePicker.RangePicker
          defaultValue={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : [null, null]}
          style={{ width: '100%' }}
          format={USER_DATE_FORMAT}
          onChange={(dates) => {
            handleFieldChange(record.id, 'dateRange', dates);
          }}
          disabledDate={calendarName ? (date) => getDisabledDate(calendarName, date) : undefined}
        />
      );
    },
  },
  {
    key: 'controls',
    title: '',
    dataIndex: [],
    maxWidth: '10rem',
    render: (value: any, record: Period) => {
      return <AppTableControls remove={() => handleDeleteRow(record.id)} />;
    },
  },
];
